import { SvgIconProps } from "@mui/material";
import { FC } from "react";
import { IDynamicIcon } from "./models";
import BiotechRoundedIcon from "@mui/icons-material/BiotechRounded";
import QuizRoundedIcon from "@mui/icons-material/QuizRounded";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const DynamicIcon: FC<SvgIconProps & IDynamicIcon> = (
  { icon, style },
  props
) => {
  switch (icon) {
    case "BiotechIcon":
      return <BiotechRoundedIcon {...props} style={style} />;
    case "QuizRoundedIcon":
      return <QuizRoundedIcon {...props} style={style} />;
    case "WhatsAppIcon":
      return <WhatsAppIcon {...props} style={style} />;
    default:
      return null;
  }
};

export default DynamicIcon;
